/**
 * Format a Unix timestamp to a localized date string (no time)
 * @param {number} timestamp - Unix timestamp (can include decimal places)
 * @returns {string} - Formatted date string in user's locale
 */
export const formatDate = (timestamp) => {
  // Handle invalid or missing timestamp
  if (!timestamp || isNaN(timestamp)) {
    return '';
  }
  
  try {
    // Convert to milliseconds (JavaScript Date expects milliseconds)
    // Math.floor to handle decimal timestamps
    const date = new Date(Math.floor(timestamp) * 1000);
    
    // Check if date is valid
    if (isNaN(date.getTime())) {
      return '';
    }
    
    // Return localized date string (no time)
    return date.toLocaleDateString(undefined, {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  } catch (error) {
    console.error('Error formatting date:', error);
    return '';
  }
};

/**
 * Format a Unix timestamp to uppercase date string (e.g., "12 DEC 2024")
 * @param {number} timestamp - Unix timestamp (can include decimal places)
 * @returns {string} - Formatted uppercase date string
 */
export const formatDateUppercase = (timestamp) => {
  const formattedDate = formatDate(timestamp);
  return formattedDate ? formattedDate.toUpperCase() : '';
};